import { Api } from 'utils';

class AccreditationService {
		
	static admin = {
		getPayments: async (params?: any) => Api.createResponse('admin/accreditations/payments',params),
		getHistory: async (params?: any) => Api.createResponse('admin/accreditations/history',params),
		view: async (params?: any) => Api.createResponse('admin/accreditations/view',params),
		save: async (params?: any) => Api.createResponse('admin/accreditations/save',params),
		getConfig: async (params?: any) => Api.createResponse('admin/accreditations/config',params),
		saveConfig: async (params?: any) => Api.createResponse('admin/accreditations/save-config',params),
		setPayment: async (params?: any) => Api.createResponse('admin/accreditations/save-payment',params),
		saveManualAccreditation: async (params?: any) => Api.createResponse('admin/accreditations/save-manual-accreditation',params),
		getPaymentData: async (params?: any) => Api.createResponse('admin/accreditations/payment-data',params),
	}

}

export default AccreditationService;